import { render } from "./Illustration.vue?vue&type=template&id=02f00397"
import script from "./Illustration.vue?vue&type=script&lang=js"
export * from "./Illustration.vue?vue&type=script&lang=js"
script.render = render

export default script